// ------------------------------------------------------------------------------
// name: order
// author: mudas
// created: 2024/12/6
// ------------------------------------------------------------------------------

export enum OrderRule {
  COLLABORATIONS = 'COLLABORATIONS',
  RECENTLY_JOINED = 'RECENTLY_JOINED',
}
